module.exports = __webpack_public_path__ + "img/github_icon_white.86390c69.png";